export const FILTER_PATH_SEPARATOR = '/-/';

/**
 * Extracts the base path (before the /-/ separator) from a full URL path or asPath string.
 * Returns the full path when no filter separator is present.
 *
 * A trailing slash is stripped from the result (except for the root path `/`)
 * because {@link build} from `@noths/polaris-product-listings-urls` expects
 * `basePath` with no trailing slash — a trailing slash would produce a
 * double-slash (`//-/`) in the built URL.
 */
export const extractBasePath = (asPath: string): string => {
  const pathOnly = asPath.split('?')[0].split('#')[0];
  const separatorIndex = pathOnly.indexOf(FILTER_PATH_SEPARATOR);
  const base = separatorIndex === -1 ? pathOnly : pathOnly.slice(0, separatorIndex);

  return base.length > 1 ? base.replace(/\/+$/, '') : base;
};
